<div
  class="acp-root"
  [class.acp-root--open]="open"
  [class.acp-root--rtl]="isRTL"
>
  <div
    *ngIf="open"
    class="acp-backdrop"
    aria-hidden="true"
    (click)="onClose()"
  ></div>

  <div *ngIf="open" class="acp-shell">
    <aside class="acp-panel" role="dialog" aria-modal="true"
           [attr.aria-label]="'ATTRIBUTE.MODAL.TITLE' | translate">

      <!-- ======================== LIST VIEW ======================== -->
      <ng-container *ngIf="currentView === 'list'">
        <header class="acp__header">
          <h2 class="acp__title">{{ "ATTRIBUTE.MODAL.TITLE" | translate }}</h2>
          <button type="button" class="acp__close" (click)="onClose()"
                  [attr.aria-label]="'APP_BUTTONS.CANCEL' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </header>

        <div class="acp__search">
          <input type="text" class="acp__search-input"
                 [(ngModel)]="searchTerm"
                 (ngModelChange)="onSearchChange()"
                 [placeholder]="'ATTRIBUTE.MODAL.SEARCH' | translate" />
        </div>

        <div class="acp__list">
          <div
            *ngIf="isLoading"
            class="acp__loader-wrap"
            role="status"
            [attr.aria-label]="'APP_BUTTONS.LOADING' | translate"
          >
            <span class="acp__loader" aria-hidden="true"></span>
          </div>

          <div *ngIf="!isLoading && paginatedAttributes.length === 0" class="acp__empty">
            {{ "ATTRIBUTE.MODAL.NO_ATTRIBUTES" | translate }}
          </div>

          <ng-container *ngIf="!isLoading">
          <div *ngFor="let attr of paginatedAttributes" class="acp__item">
            <span class="acp__icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                   stroke-linejoin="round" aria-hidden="true">
                <path d="M12 2 2 7l10 5 10-5-10-5Z" />
                <path d="m2 17 10 5 10-5" />
                <path d="m2 12 10 5 10-5" />
              </svg>
            </span>

            <div class="acp__info">
              <span class="acp__name">{{ getAttributeName(attr) }}</span>
              <div class="acp__meta">
                <span *ngIf="attr.attributeType" class="acp__pill">{{ "ATTRIBUTE.FORM." + attr.attributeType | translate }}</span>

                <label class="acp__toggle">
                  <input
                    type="checkbox"
                    class="acp__toggle-input"
                    [checked]="!attr.archived"
                    (change)="toggleArchive(attr)"
                  />
                  <span class="acp__toggle-track"></span>
                  <span class="acp__toggle-label" [class.acp__toggle-label--active]="!attr.archived">
                    {{ !attr.archived
                      ? ("ATTRIBUTE.MODAL.ACTIVE" | translate)
                      : ("ATTRIBUTE.MODAL.ARCHIVED" | translate) }}
                  </span>
                </label>
              </div>
              <span *ngIf="getValuesPreview(attr)" class="acp__values-preview">
                {{ getValuesPreview(attr) }}
              </span>
            </div>

            <div class="acp__actions">
              <button type="button" class="acp__action-btn"
                      (click)="openEditForm(attr)"
                      [attr.aria-label]="'APP_BUTTONS.EDIT' | translate">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round"
                     stroke-linejoin="round">
                  <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                  <path d="m15 5 4 4" />
                </svg>
              </button>
            </div>
          </div>
          </ng-container>
        </div>

        <div class="ct__pagination" *ngIf="totalElements > pageSize && !isLoading">
          <span class="ct__pagination-range">
            {{ rangeStart }}&ndash;{{ rangeEnd }} {{ "PAGINATOR.OF" | translate }} {{ totalElements }}
          </span>
          <div class="ct__pagination-nav">
            <button type="button" class="ct__pagination-btn"
                    [disabled]="!canGoPrevious" (click)="goPrevious()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>
              <span>{{ "PAGINATOR.PREVIOUS_PAGE" | translate }}</span>
            </button>
            <button type="button" class="ct__pagination-btn"
                    [disabled]="!canGoNext" (click)="goNext()">
              <span>{{ "PAGINATOR.NEXT_PAGE" | translate }}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>
            </button>
          </div>
        </div>

        <footer class="acp__footer">
          <button type="button" class="btn-pill btn-pill--primary" (click)="openCreateForm()">
            + {{ "ATTRIBUTE.MODAL.ADD" | translate }}
          </button>
        </footer>
      </ng-container>

      <!-- ======================== FORM VIEW ======================== -->
      <ng-container *ngIf="currentView === 'form'">
        <header class="acp__header">
          <button type="button" class="acp__back" (click)="backToList()"
                  [attr.aria-label]="'ATTRIBUTE.MODAL.BACK' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>
          <h2 class="acp__title">
            {{ isEditMode
              ? ("ATTRIBUTE.MODAL.FORM_TITLE_EDIT" | translate)
              : ("ATTRIBUTE.MODAL.FORM_TITLE_CREATE" | translate) }}
          </h2>
          <button type="button" class="acp__close" (click)="onClose()"
                  [attr.aria-label]="'APP_BUTTONS.CANCEL' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </header>

        <div class="acp__form-body" *ngIf="attributeForm" [formGroup]="attributeForm">
          <div
            *ngIf="isLoading"
            class="acp__loader-wrap acp__loader-wrap--form"
            role="status"
            [attr.aria-label]="'APP_BUTTONS.LOADING' | translate"
          >
            <span class="acp__loader" aria-hidden="true"></span>
          </div>

          <ng-container *ngIf="!isLoading">
            <!-- name -->
            <div class="acp__field">
              <label class="acp__label">{{ "ATTRIBUTE.FORM.NAME" | translate }}</label>
              <input type="text" class="acp__input"
                     [class.acp__input--invalid]="attributeForm.get('name')?.invalid && attributeForm.get('name')?.touched"
                     formControlName="name" />
              <span class="acp__error"
                    *ngIf="attributeForm.get('name')?.invalid && attributeForm.get('name')?.touched">
                {{ "APP_GENERIC_ALERTS.FIELD_REQUIRED" | translate }}
              </span>
            </div>

            <!-- attributeType -->
            <div class="acp__field">
              <label class="acp__label">{{ "ATTRIBUTE.FORM.TYPE" | translate }}</label>
              <select class="acp__select" formControlName="attributeType"
                      [class.acp__input--invalid]="attributeForm.get('attributeType')?.invalid && attributeForm.get('attributeType')?.touched"
                      (change)="attributeTypeChange()">
                <option [ngValue]="null" disabled>{{ "ATTRIBUTE.FORM.SELECT_TYPE" | translate }}</option>
                <option *ngFor="let type of attributeTypes"
                        [ngValue]="type">{{ "ATTRIBUTE.FORM." + type | translate }}</option>
              </select>
              <span class="acp__error"
                    *ngIf="attributeForm.get('attributeType')?.invalid && attributeForm.get('attributeType')?.touched">
                {{ "APP_GENERIC_ALERTS.FIELD_REQUIRED" | translate }}
              </span>
            </div>

            <!-- List / MultiSelect values section -->
            <div class="acp__list-values-section" *ngIf="isListAttribute" formArrayName="attributeListValues">
              <label class="acp__label">{{ "ATTRIBUTE.MODAL.VALUES_LABEL" | translate }}</label>

              <div *ngFor="let control of attributeListValuesArray.controls; let i = index"
                   class="acp__list-value-item" [formGroupName]="i">
                <div class="acp__list-value-row">
                  <input type="text" class="acp__list-value-input"
                         formControlName="value"
                         [class.acp__input--invalid]="control.get('value')?.invalid && control.get('value')?.touched" />
                  <button type="button" class="acp__list-value-remove"
                          *ngIf="attributeListValuesArray.length > 1"
                          (click)="removeListValue(i)"
                          [attr.aria-label]="'APP_BUTTONS.DELETE' | translate">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round"
                         stroke-linejoin="round">
                      <path d="M3 6h18" />
                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                    </svg>
                  </button>
                </div>
                <span class="acp__error" *ngIf="control.get('value')?.invalid && control.get('value')?.touched">
                  {{ "ATTRIBUTE.FORM.VALUE_REQUIRED" | translate }}
                </span>
              </div>

              <button type="button" class="btn-pill btn-pill--small" (click)="addListValue()">
                + {{ "ATTRIBUTE.MODAL.ADD_VALUE" | translate }}
              </button>
            </div>
          </ng-container>
        </div>

        <footer class="acp__form-footer">
          <button type="button" class="btn-pill btn-pill--secondary" (click)="backToList()">
            {{ "APP_BUTTONS.CANCEL" | translate }}
          </button>
          <button type="button" class="btn-pill btn-pill--primary" [class.btn-pill--save]="!isSaving"
                  [disabled]="isSaving" (click)="submitForm()"
                  [attr.aria-label]="isSaving ? ('APP_BUTTONS.LOADING' | translate) : ('APP_BUTTONS.SAVE' | translate)">
            <span *ngIf="isSaving" class="acp__btn-spinner" aria-hidden="true"></span>
            <span *ngIf="!isSaving">{{ "APP_BUTTONS.SAVE" | translate }}</span>
          </button>
        </footer>
      </ng-container>

    </aside>
  </div>
</div>
